import React, { useState } from "react"
import { createPortal } from "react-dom"
import styled from "@emotion/styled"
import { Flex, Box } from "@rebass/grid/emotion"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import { ButtonWildMen } from "@nutrafol/nutrafol-ui-kit/dist/ButtonWildMen"
import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"
import { ModalWild } from "@nutrafol/nutrafol-ui-kit/dist/ModalWild"

import Modal from "./modalInfomen"
import { data } from "../../../data/data_headspace"

const Wrapper = styled(Box)`
  button {
    font-size: 12px !important;
  }

  h3 {
    text-align: left !important;
    margin-bottom: 8px;
  }
`

const Details = () => {
  const [modalActive, setModalActive] = useState(false)

  const handleClick = () => {
    setModalActive(true)
    segmentEvent("Modal Viewed", {
      name: data.buttonText,
    })
  }

  return (
    <Wrapper>
      <TextElementMen
        element="h3"
        text={data.heading}
        className="hide-md-up body--small-b text-men-secondary-secondary"
      />
      <TextElementMen
        element="h3"
        text={data.heading}
        className="show-md-up body--regular-b text-men-secondary-secondary"
      />
      {data.items.map((item, index) => {
        const Icon = item.image
        return (
          <Flex
            key={`item-${index}`}
            marginBottom={"8px"}
            alignItems={"center"}
          >
            <Box marginRight={"8px"}>
              <Icon />
            </Box>
            <Box>
              <TextElementMen
                element="p"
                text={item.text}
                className="hide-md-up body--small text-men-secondary-secondary"
              />
              <TextElementMen
                element="p"
                text={item.text}
                className="show-md-up body--regular text-men-secondary-secondary"
              />
            </Box>
          </Flex>
        )
      })}
      <ButtonWildMen
        textLink
        label={data.buttonText}
        onClick={() => handleClick()}
      />
      {modalActive
        ? createPortal(
            <ModalWild
              className="headspace-modal"
              component={Modal}
              propsObject={{ data }}
              hideModal={() => setModalActive(false)}
              customZIndex={9999}
            />,
            document.body
          )
        : null}
    </Wrapper>
  )
}

export default Details
